export const GROUPS = {
  GENERAL: 'general',
  ADMINISTRATOR: 'administrator',
  TECHNICIAN: 'technician',
  ENGINEERING: 'engineering',
  PLANNING: 'planning',
};
